

export function Home(){
   
    
    return (<p>Inicio</p>)
}